/**
 * AWS Cognito SRP Authentication
 * Simple SRP authentication for password security
 */

import { srpLogin } from "./srpLogin.js";

const newPoolData = {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "",
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "",
};

const legacyPoolData = {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID_LEGACY || "",
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID_LEGACY || "",
};


export const signInNew = (username, password) => {

  return new Promise(async (resolve, reject) => {
    try {
      const tokens = await srpLogin({
        region: process.env.REACT_APP_AWS_REGION,
        userPoolId: newPoolData.UserPoolId,
        clientId: newPoolData.ClientId,
        username: username,
        password: password,
      });

      resolve(tokens);
    } catch (error) {
      reject(error);
    }
  });
};


export const signInLegacy = (username, password) => {
  return new Promise(async (resolve, reject) => {
    try {
      const tokens = await srpLogin({
        region: process.env.REACT_APP_AWS_REGION,
        userPoolId: legacyPoolData.UserPoolId,
        clientId: legacyPoolData.ClientId,
        username: username,
        password: password,
      });

      resolve(tokens);
    } catch (error) {
      reject(error);
    }
  });
};


export const signIn = signInNew;
